module.exports = __webpack_public_path__ + "static/video-nfts-popup-2cb92075f948f04b854a8a566b99408e.webp";